<template>
<main>
<header>
</header>
  <div id="selectAction">
     <select class="selAction" name="selectAction" v-model="logAction"> 
      <!-- @change="handleFilterChange"> -->
       <option value="NONE">Do nothing</option>
       <option value="WIP">WIP - Run job again</option>
       <option value="INIT">INIT - reprocess csv data (create job only)</option>
       <option value="DELJOB">Move to deleted and set status to DONE</option>
       <option value="ARCHJOB">Move to archived and set status to DONE</option>
       <option value="UNDELJOB">Move from deleted to standard</option>
       <option value="UNARCHJOB">Move from archived to standard</option>
     </select>
  </div>
  <div id="tabHead">
    <table-lite
      :key="'head-' + tabHead.rows.length"
      :is-hide-paging="true"
      :columns="tabHead.columns"
      :rows="tabHead.rows"
      @row-clicked="rowClicked"
    >
    </table-lite>
  </div>
  <div id="tabLogs">
    <table-lite
      :key="'logs-' + tabLogs.rows.length"
      :is-hide-paging="true"
      :columns="tabLogs.columns"
      :rows="tabLogs.rows"
      :row-classes="tabLogs.rowClasses"
      @row-clicked="rowClicked"
    >
    </table-lite>
  </div>
</main>
</template>


<script>
import { ref, reactive, computed, watch, onMounted, onErrorCaptured } from 'vue'
import TableLite from "vue3-table-lite";

export default {
  name: 'AppLogComponent',
  components: {TableLite},
  props: {
    // appLog: {type: Object, required: true}
    appLog: {type: Object, default: null},
  },
  emits: ['update:logAction'],

  setup(props, { emit }) {
    // Reactive data - convert from data() function
    const wrkAction = ref('NONE')
    const jobID = ref(null)
    //const tabHeadRows = ref([])
    //const tabLogsRows = ref([])

    const tabHead = reactive({
      isLoading: false,
      totalRecordCount: 0,
      rows: [],
      columns: [
        { label: 'ID', field: 'id', isKey: true },
        { label: 'status', field: 'status' },
        { label: 'worker_id', field: 'worker_id' },
        { label: 'worker_action', field: 'worker_action' },
        { label: 'worker_payload', field: 'worker_payload' },
        { label: 'worker_response', field: 'worker_response' },
        { label: 'created', field: 'created' },
        { label: 'updated', field: 'updated' }
      ]
    })

    const tabLogs = reactive({
      isLoading: false,
      totalRecordCount: 0,
      rows: [],
      rowClasses: (row) => {
        return row.status.startsWith('catch-') ? ['rowCatch'] :
               row.status.startsWith('runCmd:') ? ['rowCmdRun'] : []
      },
      columns: [
        { label: 'ID', field: 'id', isKey: true, width: "5%" },
        { label: 'action', field: 'action' },
        { label: 'status', field: 'status' },
        { label: 'message', field: 'message', width: "50%" },
        { label: 'created', field: 'created' }
      ]
    })
    
    // Update watchers to modify reactive object properties
    watch(() => props.appLog?.head, (newHead) => {
      console.log('tabHead watcher triggered, newHead:', newHead)
      tabHead.rows = newHead ? [newHead] : []
      if (newHead) {
        jobID.value = newHead.id
      }
    }, { immediate: true })
    
    watch(() => props.appLog?.logs, (newLogs) => {
      console.log('tabLogs watcher triggered, newLogs length:', newLogs?.length || 0)
      tabLogs.rows = newLogs || []
    }, { immediate: true })


    // For the logAction computed with getter/setter, we need to create a custom v-model
    const logAction = computed({
      get: () => wrkAction.value,
      set: (val) => {
        emit('update:logAction', { jobID: jobID.value, action: val })
      }
    })
    
    const rowClicked = (row) => { console.log("Row clicked!", row); }
    onErrorCaptured((err, instance, msg) => { console.log('errorCaptured', err, msg); });
    onMounted(() => { console.table('### onMounted done');  });

    return {
          wrkAction,
          jobID,
          tabHead,
          tabLogs,
          logAction,
          rowClicked
        }
  }
}
</script>


<!-- <style scoped> -->
<style scoped>
::v-deep(.rowCmdRun) { background: #215f5e !important; }
::v-deep(.rowCatch)    { background: #5c2121 !important; }

</style>